import Vue from "vue";

/**
 * 模糊查询客户集团
 * @param params
 * @returns {*}
 */
export function combineCustomerLikeQuery(params) {
    return Vue.axios({
        url: '/api/combineCustomer/query',
        method: 'get',
        params
    })
}

/**
 * 客户集团分页列表
 * @param params
 * @returns {*}
 */
export function combineCustomerPage(params) {
    return Vue.axios({
        url: '/api/combineCustomer/page',
        method: 'get',
        params
    })
}

/**
 * 客户集团保存
 * @param data
 * @returns {*}
 */
export function combineCustomerStore(data) {
    return Vue.axios({
        url: '/api/combineCustomer/store',
        method: 'post',
        data
    })
}

/**
 * 客户集团删除
 * @param data
 * @returns {*}
 */
export function combineCustomerDelete(data) {
    return Vue.axios({
        url: '/api/combineCustomer/delete',
        method: 'post',
        data
    })
}

/**
 * 模糊查询品牌集团
 * @param params
 * @returns {*}
 */
export function combineBrandLikeQuery(params) {
    return Vue.axios({
        url: '/api/combineBrand/query',
        method: 'get',
        params
    })
}

/**
 * 品牌集团分页列表
 * @param params
 * @returns {*}
 */
export function combineBrandPage(params) {
    return Vue.axios({
        url: '/api/combineBrand/page',
        method: 'get',
        params
    })
}

export function combineBrandMap(params) {
    return Vue.axios({
        url: '/api/combineBrand/mapList',
        method: 'get',
        params
    })
}

/**
 * 品牌集团远程搜索 options
 * @param params
 * @returns {*}
 */
export function getCombineBrandOptions(params) {
    return Vue.axios({
        url: '/api/combineBrand/options',
        method: 'get',
        params
    })
}

/**
 * 品牌集团保存
 * @param data
 * @returns {*}
 */
export function combineBrandStore(data) {
    return Vue.axios({
        url: '/api/combineBrand/store',
        method: 'post',
        data
    })
}

/**
 * 品牌集团删除
 * @param data
 * @returns {*}
 */
export function combineBrandDelete(data) {
    return Vue.axios({
        url: '/api/combineBrand/delete',
        method: 'post',
        data
    })
}
